export class Account {
  ID?: number;
  Email: string;
  Name: string;
  IsEnabled?: boolean;
  RoleCode: string;
  ExternalID?: string;
  Password: string;
  ExpirationDate?: Date;
}
